import React, { Component } from 'react';

export class ColumnsIcon extends Component {
    static displayName = ColumnsIcon.name;

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        let format = this.props.format;

        let icon;
        switch (format) {
            case "1-1-1-1":
                icon = <div style={OneOneOneOne}>
                    <div style={column1}></div>
                    <div style={column1}></div>
                    <div style={column1}></div>
                    <div style={column1End}></div>
                </div>;
                break;
            case "2-1-1":
                icon = <div style={TwoOneOne}>
                    <div style={column2}></div>
                    <div style={column1}></div>
                    <div style={column1End}></div>
                </div>;
                break;
            case "1-1-2":
                icon = <div style={OneOneTwo}>
                    <div style={column1}></div>
                    <div style={column1}></div>
                    <div style={column2End}></div>
                </div>;
                break;
            case "2-2":
                icon = <div style={TwoTwo}>
                    <div style={column2}></div>
                    <div style={column2End}></div>
                </div>;
                break;
            case "4":
                icon = <div style={Four}>
                    <div style={column4End}></div>
                </div>;
            default:
                break;
        }

        return (
            <div>
                {icon}
            </div>  
        );
    }
}

const OneOneOneOne = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gridGap: '0px',
    width: '50px',
    height: '45px',
    borderRadius: '5px',
    border: '2px solid #3c8dbc'
}

const TwoOneOne = {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr',
    gridGap: '0px',
    width: '50px',
    height: '45px',
    borderRadius: '5px',
    border: '2px solid #3c8dbc'
}

const OneOneTwo = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 2fr',
    gridGap: '0px',
    width: '50px',
    height: '45px',
    borderRadius: '5px',
    border: '2px solid #3c8dbc'
}

const TwoTwo = {
    display: 'grid',
    gridTemplateColumns: '2fr 2fr',
    gridGap: '0px',
    width: '50px',
    height: '45px',
    borderRadius: '5px',
    border: '2px solid #3c8dbc'
}

const Four = {
    display: 'grid',
    gridTemplateColumns: '4fr',
    gridGap: '0px',
    width: '50px',
    height: '45px',
    borderRadius: '5px',
    border: '2px solid #3c8dbc'
}

const column1 = {
    gridColumn: 'span 1',
    borderRight: '2px solid #3c8dbc'
}

const column1End = {
    gridColumn: 'span 1'
}

const column2 = {
    //gridColumn: 'span 2',
    borderRight: '2px solid #3c8dbc'
}

const column2End = {
    //gridColumn: 'span 2'
}

const column4End = {

}

export default ColumnsIcon;
